(function(){
  var ann=document.querySelector(".announce");
  if(ann){
    var ps=ann.querySelectorAll("p");
    if(ps.length>1){ var i=0; setInterval(function(){ ps[i].classList.remove("is-on"); i=(i+1)%ps.length; ps[i].classList.add("is-on"); },4500); }
  }
  var openB=document.getElementById("menuOpen"), closeB=document.getElementById("menuClose"),
      mnav=document.getElementById("mnav"), scrim=document.getElementById("scrim");
  function setOpen(o){
    if(mnav){ mnav.classList.toggle("is-open",o); mnav.setAttribute("aria-hidden", o?"false":"true"); }
    if(scrim) scrim.classList.toggle("is-open",o);
    if(openB) openB.setAttribute("aria-expanded", o?"true":"false");
    document.documentElement.style.overflow = o?"hidden":"";
  }
  if(openB) openB.addEventListener("click",function(){ setOpen(true); });
  if(closeB) closeB.addEventListener("click",function(){ setOpen(false); });
  if(scrim) scrim.addEventListener("click",function(){ setOpen(false); });
})();
